/**
 * VETRO product hero: option radios → variant id, availability, gallery.
 * #vetro-product-form, #vetro-product-variants-data; optional gallery via window.vetroProductGalleryGoTo.
 */
(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function optionCount(variants) {
    return variants[0] && variants[0].options ? variants[0].options.length : 0;
  }

  /** For each option index, which string values appear on at least one variant (any stock). */
  function valueSetsByOptionIndex(variants) {
    var n = optionCount(variants);
    var sets = [];
    for (var i = 0; i < n; i++) sets[i] = Object.create(null);
    for (var v = 0; v < variants.length; v++) {
      var opts = variants[v].options;
      for (var i = 0; i < opts.length; i++) sets[i][opts[i]] = true;
    }
    return sets;
  }

  function getSelectionArray(form) {
    var maxPos = 0;
    form.querySelectorAll('input[type="radio"][data-option-position]').forEach(function (inp) {
      var p = parseInt(inp.getAttribute('data-option-position'), 10);
      if (!Number.isNaN(p) && p > maxPos) maxPos = p;
    });
    var sel = [];
    for (var i = 0; i < maxPos; i++) sel[i] = null;
    form.querySelectorAll('input[type="radio"][data-option-position]:checked').forEach(function (inp) {
      var p = parseInt(inp.getAttribute('data-option-position'), 10);
      if (Number.isNaN(p)) return;
      sel[p - 1] = inp.getAttribute('data-option-value');
    });
    return sel;
  }

  function variantMatchesSelectionWithOverride(v, selection, overrideIndex, overrideValue) {
    for (var i = 0; i < v.options.length; i++) {
      var want = i === overrideIndex ? overrideValue : selection[i];
      if (want != null && want !== '' && v.options[i] !== want) return false;
    }
    return true;
  }

  /** In-stock variant exists matching current selection except at overrideIndex = overrideValue. */
  function hasAvailableVariant(variants, selection, overrideIndex, overrideValue) {
    for (var v = 0; v < variants.length; v++) {
      var variant = variants[v];
      if (!variant.available) continue;
      if (variantMatchesSelectionWithOverride(variant, selection, overrideIndex, overrideValue)) return true;
    }
    return false;
  }

  function findExactVariant(variants, sel) {
    for (var v = 0; v < variants.length; v++) {
      var variant = variants[v];
      if (variant.options.length !== sel.length) continue;
      var ok = true;
      for (var i = 0; i < sel.length; i++) {
        if (variant.options[i] !== sel[i]) {
          ok = false;
          break;
        }
      }
      if (ok) return variant;
    }
    return null;
  }

  function updateAvailability(form, variants, valueSets) {
    var selection = getSelectionArray(form);
    var inputs = form.querySelectorAll('input[type="radio"][data-option-position]');
    inputs.forEach(function (inp) {
      var idx = parseInt(inp.getAttribute('data-option-position'), 10) - 1;
      var kind = inp.getAttribute('data-vetro-option-kind') || 'choice';
      var val = inp.getAttribute('data-option-value');
      var ok;
      if (kind === 'color') {
        ok = !!(valueSets[idx] && valueSets[idx][val]);
      } else {
        ok = hasAvailableVariant(variants, selection, idx, val);
      }
      inp.disabled = !ok;
      inp.setAttribute('aria-disabled', ok ? 'false' : 'true');
      var lab = form.querySelector('label[for="' + inp.id + '"]');
      if (lab) lab.classList.toggle('vetro-option-label--unavailable', !ok);
    });
  }

  function parseGalleryUrls() {
    var gel = document.getElementById('vetro-product-gallery-data');
    if (!gel) return [];
    try {
      var u = JSON.parse(gel.textContent.trim());
      return Array.isArray(u) ? u : [];
    } catch (e) {
      return [];
    }
  }

  function galleryUrlStem(u) {
    if (!u) return '';
    var s = String(u).split('?')[0];
    var m = s.match(/\/([^/?]+)$/);
    return m ? m[1] : s;
  }

  /** Match variant featured_image URL to a gallery slide index (width/query may differ). */
  function galleryIndexForFeatured(featuredUrl, galleryUrls) {
    if (!featuredUrl || !galleryUrls.length) return -1;
    var a = String(featuredUrl).split('?')[0];
    var stemA = galleryUrlStem(a);
    for (var i = 0; i < galleryUrls.length; i++) {
      var b = String(galleryUrls[i]).split('?')[0];
      if (a === b) return i;
      var stemB = galleryUrlStem(b);
      if (
        stemA &&
        stemB &&
        stemA.length >= 6 &&
        stemB.length >= 6 &&
        (stemA === stemB || stemA.indexOf(stemB) !== -1 || stemB.indexOf(stemA) !== -1)
      )
        return i;
    }
    return -1;
  }

  /** If this variant has no image, use first variant with same color that does (common Shopify setup). */
  function galleryIndexForColorFallback(form, variants, sel, galleryUrls) {
    var checked = form.querySelector('input[type="radio"][data-vetro-option-kind="color"]:checked');
    if (!checked || !galleryUrls.length) return -1;
    var cIdx = parseInt(checked.getAttribute('data-option-position'), 10) - 1;
    if (cIdx < 0 || !sel[cIdx]) return -1;
    var colorVal = sel[cIdx];
    for (var v = 0; v < variants.length; v++) {
      var variant = variants[v];
      if (!variant.options || variant.options[cIdx] !== colorVal) continue;
      if (typeof variant.image_index === 'number' && !Number.isNaN(variant.image_index)) return variant.image_index;
      if (variant.featured_image) {
        var gi = galleryIndexForFeatured(variant.featured_image, galleryUrls);
        if (gi >= 0) return gi;
      }
    }
    if (window.vetroColorImageMatch && typeof window.vetroColorImageMatch.urlMatchesColor === 'function') {
      for (var u = 0; u < galleryUrls.length; u++) {
        if (window.vetroColorImageMatch.urlMatchesColor(galleryUrls[u], colorVal)) return u;
      }
    }
    return -1;
  }

  function ensureValidSelection(form) {
    var groups = {};
    form.querySelectorAll('input[type="radio"][data-option-position]').forEach(function (inp) {
      var p = inp.getAttribute('data-option-position');
      if (!groups[p]) groups[p] = [];
      groups[p].push(inp);
    });
    Object.keys(groups).forEach(function (posKey) {
      var list = groups[posKey];
      var checked = list.filter(function (i) {
        return i.checked;
      })[0];
      if (checked && !checked.disabled) return;
      var first = list.find(function (i) {
        return !i.disabled;
      });
      if (!first) {
        if (checked) checked.checked = false;
        return;
      }
      list.forEach(function (i) {
        i.checked = false;
      });
      first.checked = true;
    });
  }

  function updateAddToCartButton(form, variant) {
    var btn = form.querySelector('button[name="add"]');
    if (!btn || !variant) return;
    var addLabel = form.getAttribute('data-vetro-label-add') || '';
    var soldLabel = form.getAttribute('data-vetro-label-sold') || '';
    var textEl = btn.querySelector('.add-to-cart-text__content span span');
    btn.disabled = !variant.available;
    if (textEl) {
      textEl.textContent = variant.available ? addLabel : soldLabel;
    }
    var iconWrap = btn.querySelector('.add-to-cart-icon');
    if (iconWrap) {
      iconWrap.style.display = variant.available ? '' : 'none';
    }
  }

  function applyVariant(form, variant, galleryUrls, variants) {
    var idInput = form.querySelector('[data-vetro-variant-id-input]');
    if (!idInput || !variant) return;
    idInput.value = String(variant.id);
    updateAddToCartButton(form, variant);

    var sel = [];
    var maxPos = 0;
    form.querySelectorAll('input[type="radio"][data-option-position]').forEach(function (inp) {
      var p = parseInt(inp.getAttribute('data-option-position'), 10);
      if (!Number.isNaN(p) && p > maxPos) maxPos = p;
    });
    for (var s = 0; s < maxPos; s++) sel[s] = null;
    form.querySelectorAll('input[type="radio"][data-option-position]:checked').forEach(function (inp) {
      var p = parseInt(inp.getAttribute('data-option-position'), 10);
      if (!Number.isNaN(p)) sel[p - 1] = inp.getAttribute('data-option-value');
    });

    var idx = -1;
    if (typeof variant.image_index === 'number' && !Number.isNaN(variant.image_index)) {
      idx = variant.image_index;
    } else if (variant.featured_image && galleryUrls.length) {
      idx = galleryIndexForFeatured(variant.featured_image, galleryUrls);
    }
    if (idx < 0) {
      idx = galleryIndexForColorFallback(form, variants, sel, galleryUrls);
    }

    if (idx >= 0 && typeof window.vetroProductGalleryGoTo === 'function') {
      window.vetroProductGalleryGoTo(idx);
      return;
    }

    var mainImg = document.getElementById('mainImg');
    var imgSrc = variant.featured_image;
    if (!imgSrc) {
      var altIdx = galleryIndexForColorFallback(form, variants, sel, galleryUrls);
      if (altIdx >= 0 && galleryUrls[altIdx]) imgSrc = galleryUrls[altIdx];
    }
    if (mainImg && imgSrc) {
      mainImg.src = imgSrc;
      mainImg.removeAttribute('srcset');
    }
  }

  function syncFromForm(form, variants, valueSets, galleryUrls) {
    updateAvailability(form, variants, valueSets);
    ensureValidSelection(form);
    var sel = getSelectionArray(form);
    var complete = sel.every(function (x) {
      return x != null && x !== '';
    });
    if (!complete) return;
    var variant = findExactVariant(variants, sel);
    if (variant) applyVariant(form, variant, galleryUrls, variants);
  }

  onReady(function () {
    var form = document.getElementById('vetro-product-form');
    var dataEl = document.getElementById('vetro-product-variants-data');
    if (!form || !dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent.trim());
    } catch (e) {
      return;
    }
    if (!Array.isArray(variants) || variants.length === 0) return;

    var valueSets = valueSetsByOptionIndex(variants);
    var galleryUrls = parseGalleryUrls();

    form.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches('input[type="radio"][data-option-position]')) return;
      syncFromForm(form, variants, valueSets, galleryUrls);
    });

    syncFromForm(form, variants, valueSets, galleryUrls);
  });
})();
